/**
 * リストが3つ以上のアイテムを保持しているかどうか
 */
export const hasListThreeMoreItem = <T>(list: T[]): boolean => list?.length > 2;
